import { FiltersQuery } from "../../api/typings/Filters";

export interface UserFilterQuerySerialized extends FilterQuerySerialized {
  "filter[only_trashed]": "0" | "1";
}

export interface ParentsFilterQuerySerialized extends FilterQuerySerialized {
  "filter[profiles][parent][is_expired_subscription_payment_allowed]": "0" | "1";
}

export interface StudentsFilterQuerySerialized extends FilterQuerySerialized {
  "filter[profiles][student][is_studying]": "0" | "1";
  "filter[profiles][student][payment_comment]": string;
}

export type FilterQuerySerialized = {
  "filter[id][]": string;
  "filter[name]": string;
  "filter[email]": string;
  "filter[phone]": string;
};

export type FiltersQuerySerialized =
  | UserFilterQuerySerialized
  | ParentsFilterQuerySerialized
  | StudentsFilterQuerySerialized;

export type MergedFiltersQuerySerialized = UserFilterQuerySerialized &
  ParentsFilterQuerySerialized &
  StudentsFilterQuerySerialized;

export function getFiltersParamsSerialized<T extends FiltersQuery, R extends FiltersQuerySerialized>(params: T): R {
  const result: any = {};
  const keys = Object.entries(params);
  keys.forEach(([key, value]) => {
    if (key !== "with_trashed") {
      const serializedKey = `filter${key
        .split("-")
        .map((el: string) => `[${el}]`)
        .join("")}`;
      if (value !== "" && value != null) {
        result[serializedKey] = value;
      }
    } else if (value !== "" && value != null) {
      result[key] = value;
    }
  });
  return result;
}
